export default "__VITE_ASSET__bde9331b__"